import gql from 'graphql-tag'

export { AddressFields as IAddress } from './__generated__/AddressFields'

export const AddressFieldsFragment = gql`
  fragment AddressFields on Address {
    id
    line1
    line2
    city
    state
    postalCode
    country
    latitude
    longitude
  }
`
